import React from 'react';

export default function UeberUns({ heading, text }) {
  return (
    <section style={styles.section}>
      <div style={styles.inner}>
        <div style={styles.textSide}>
          <span style={styles.eyebrow}>Unsere Geschichte</span>
          <h2 style={styles.heading}>{heading}</h2>
          <div style={styles.divider} />
          <p style={styles.text}>{text}</p>
        </div>
        <div style={styles.iconSide}>
          <div style={styles.iconBox}>
            <span style={styles.bigIcon}>🏕️</span>
            <div style={styles.iconStat}><strong>Familiengeführt</strong></div>
          </div>
          <div style={styles.iconBox}>
            <span style={styles.bigIcon}>🌄</span>
            <div style={styles.iconStat}><strong>Traumhafte</strong><span>Naturlage</span></div>
          </div>
          <div style={styles.iconBox}>
            <span style={styles.bigIcon}>❤️</span>
            <div style={styles.iconStat}><strong>Herzliche</strong><span>Gastgeber</span></div>
          </div>
        </div>
      </div>
    </section>
  );
}

const styles = {
  section: { backgroundColor: 'white', padding: '5rem 1.5rem' },
  inner: { maxWidth: '1100px', margin: '0 auto', display: 'flex', gap: '4rem', alignItems: 'center', flexWrap: 'wrap' },
  textSide: { flex: '1 1 340px' },
  eyebrow: { fontSize: '0.82rem', fontFamily: "'Nunito', Arial, sans-serif", fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: '#40916c' },
  heading: { color: '#1b4332', fontFamily: "'Nunito', Arial, sans-serif", fontSize: 'clamp(1.6rem,4vw,2.4rem)', fontWeight: '800', marginTop: '0.5rem', marginBottom: '1rem', lineHeight: '1.2' },
  divider: { width: '50px', height: '4px', borderRadius: '4px', background: 'linear-gradient(90deg, #40916c, #52b788)', marginBottom: '1.2rem' },
  text: { color: '#4a6558', fontFamily: "'Nunito', Arial, sans-serif", fontSize: '1.05rem', lineHeight: '1.85', whiteSpace: 'pre-wrap' },
  iconSide: { flex: '1 1 280px', display: 'flex', flexDirection: 'column', gap: '1rem' },
  iconBox: { display: 'flex', alignItems: 'center', gap: '1rem', backgroundColor: '#f0f7f2', borderRadius: '14px', padding: '1.1rem 1.5rem', boxShadow: '0 2px 8px rgba(45,106,79,0.07)' },
  bigIcon: { fontSize: '2rem', flexShrink: 0 },
  iconStat: { display: 'flex', flexDirection: 'column', fontFamily: "'Nunito', Arial, sans-serif" },
};
